import {map} from './index.js';

/*  There are 2 versions of changePage:
 *    mobile version in pageNavHistory.js
 *    responsive version that was in History.js is what's in this module
 */

function change(page, pushState) {
  var currentPage = getCurrentPage();

  // normally we want to push state, except when calling from popstate,
  // in which case pushState will be false (could use shouldPush in History.js ?)
  // or when transitioning from mobile to destop view, in which case pushState will be set to 'replace'
  // pushState may be false so do NOT replace line below with:  pushState = pushState || 'push'
  pushState = pushState === undefined ? 'push' : pushState;

  // Worland Pubworks calls changePage() 2x when a new maintenance record is added.
  // Don't do anything if we're already on the page.
  if (currentPage.id !== page) {
    window.scrollTo(0, 0); // 2018-04-21 scroll to top of current page before changing pages to keep mobile browser's navigation bar from covering up map buttons
    if (currentPage.id) {
      currentPage.style.display = 'none';
    }
    document.getElementById(page).style.display = 'block';
    if (page === 'mappage' && map) {
      map.updateSize();
    }

    // seems like calling rwg.historyManager.push() would be better because it would keep all pushs in one place
    if (pushState === 'push') {
      history.pushState({page: page}, '', location.toString());

      // rwg.history.push(history.state); rwg.history is just for debugging
      // console.log('changePage pushState' /*, rwg.history.length, JSON.stringify(rwg.history), 'browser:', history.length, history.state */ );
      // rwg.history.forEach(e => console.log(e))
    } else if (pushState === 'replace') {
      // console.log('changePage replaceState');
      history.replaceState({page: page}, '', location.toString());
    }
  }
}

function changePage(page, pushState) {
  if (!page) return;
  if (rwg.layout && rwg.layout.get() !== 'paged') return;
  change(page, pushState);
}

function getCurrentPage() {
  var currentPage = {id:null};  // this is so that the "id" of the returned object can be tested w/o error
  // IE requires polyfill in util.js for NodeList.forEach() below
  document.querySelectorAll('.ui-page').forEach(function(p) {
    // offsetParent doesn't return expected result on fixed position element, specifically "mappage"
    if (p.offsetParent !== null || p.style.display === 'block') currentPage = p;
    // console.log(p.id, p.offsetParent, p.style.display);
  });
  return currentPage;
}

// 2019-08 this is just for tcwp right now
// called in tcwp/etc/conf.js and gwmap/src/History.js
window.changePageOrTab = function(page, pushState) {
  if (!page) return;
  if (rwg.layout.get() === 'tabbed') {
    rwg.activateTab(rwg.topTabs, {
      'name': 'tcwp-tab',
      'title': 'Weed & Pest',
      // contentId: 'tcwp-tab-panel'
      // "allowClose": "false"
    });
  }

  let tcwp_element = document.querySelector('#tcwp-elements');
  if (tcwp_element) {
    let children = tcwp_element.children;
    for (let e of children) {
      if (e.classList.contains('ui-page')) {
        e.style.display = 'none';
      }
    }
  }
  change(page, pushState);
};

export {changePage, getCurrentPage};
